import logo from '@/assets/member/logo.png';
import { store } from './store';

export default () => {
  store.state.propertyList = [{
    propGuid: '1',
    propName: ' ',
    propStatus: 0,
  }, {
    propGuid: '2',
    propName: ' ',
    propStatus: 0,
  }, {
    propGuid: '3',
    propName: ' ',
    propStatus: 0,
  }, {
    propGuid: '4',
    propName: ' ',
    propStatus: 0,
  }];

  store.state.taskList = [{
    isDownloadApp: true,
    completeStatus: 0,
    taskIcon: logo,
    xcxActionUrl: 'https://m.hellobike.com/ebike-h5/latest/index.html#/activity/common?guid=293b5490191e44fcaf2b39ad1fa93e22',
    taskName: 'APP会员加速升级',
    actionName: '去下载',
    awardDesc: '福利翻倍 成长值×2',
  }];
};
